
define(
	'DC.CategoryCustomization.Description'
,   [
		'DC.CategoryCustomization.Description.View'
	]
,   function (
		DescriptionView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */
			var layout = container.getComponent('Layout');
			var plp = container.getComponent('PLP');
			
			if(layout && plp)
			{
				plp.on('beforeShowContent', function () {
					var categoryinfo = plp.getCategoryInfo();
					//add data-view to facets_browse_category_heading.tpl for rendering purpose.(or anywhere you want to display content)
					layout.registerView('Category.Rich.Description', function () {
						return new DescriptionView({
							container: container,
							id: categoryinfo.internalid
						});
					});
				})
			}

		}
	};
});
